const styles = theme => ({
    autoComplete: {
        display: 'inline'
    },
    root: {
        '& .MuiTextField-root': {
            minWidth: '25ch',
        },
        '& .MuiTableCell-head': {
            fontWeight: 'bold'
        },
        '& a': {
            color: 'white'
        }
    },
    deleteButton: {
        color: '#d90000'
    }
});

export default styles;